module.exports = __webpack_public_path__ + "static/media/eyewrap2.0590a5f1.jpg";